import { resetPassword } from "aws-amplify/auth";
import { ForgotPasswordSchema } from "@validators/auth";
import { authBus } from "../AuthEvents";

export const forgotPasswordRequest = async ({ email }: ForgotPasswordSchema) => {
  try {
    // 1. Simple functional call using 'username' (which is your email)
    const output = await resetPassword({ username: email });

    // 2. Handle the success state
    const { nextStep } = output;
    if (nextStep.resetPasswordStep === "CONFIRM_RESET_PASSWORD_WITH_CODE") {
      const { codeDeliveryDetails } = nextStep;
      authBus.emitMessage(`Reset code sent to ${codeDeliveryDetails?.destination}. Please check your email.`, "success");
      authBus.emitTransition("get-reset-code");
    }
  } catch (error: any) {
    // 3. Centralized Error Handling
    let userMessage = "An error occurred. Please try again.";

    switch (error.name) {
      case "UserNotFoundException":
        userMessage = "Account not found. Please confirm your email or register.";
        break;
      case "CodeDeliveryFailureException":
        userMessage = "We couldn't deliver the code. Please check your email address.";
        break;
      case "LimitExceededException":
      case "TooManyRequestsException":
        userMessage = "Too many requests. Please wait a minute and try again.";
        break;
      case "NotAuthorizedException":
        userMessage = "This account cannot be reset at this time.";
        break;
      default:
        userMessage = error.message || userMessage;
        break;
    }

    authBus.emitMessage(userMessage, "error");
  }
};
